export default {
    DirectionChangeInvalidCallback: {
        datapoint: {
            name: 'direction_change_invalid_mutation_callback',
            customData: (records: MutationRecord[]) =>
                records.map(record => JSON.stringify(record)),
            options: {
                isQos: true,
            },
        },
    },
    DropppedFrameWhileTyping: {
        datapoint: {
            name: 'dropped_frame_while_typing',
            customData: ({ time }: { time: number }) => [time],
            options: {},
        },
    },
};
